<template>
	<div class="SpecificProvisionDetailItem">
		<span class="item-title">{{ title }}</span>
		<span class="item-header">{{ title }}</span>
		<div class="item-items">
			<div v-for="item of items" :key="item.id" class="v-chip">{{
				item.title?.[locale] ?? item.title  }}</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'SpecificProvisionDetailItem',
	props: {
		title: { type: String, required: true },
		items: { type: Array, required: true },
	},
	computed: {
		locale() {
			return this.$store.state.serviceLocale ?? 'de'
		},
	},
}
</script>

<style lang="scss" scoped>
.SpecificProvisionDetailItem {
	display: flex;
	flex-direction: column;
	.item-title {
		font-size: 17px;
		font-weight: 500;
		line-height: 22px;
		letter-spacing: -0.071px;
		padding-bottom: 16px;
	}
	.item-header {
		padding: 14px 12px;
		font-size: 15px;
		font-weight: 500;
		line-height: 20px;
		letter-spacing: -0.037px;
		text-align: left;
		border-bottom: 1px solid #e5e5e5;
	}
	.item-items {
		padding: 18px 12px;
		display: flex;
		flex-wrap: wrap;
		gap: 8px;
		width: 100%;
		.v-chip {
			height: 24px;
			border-radius: 4px;
			background: #DBDBDB;
			padding: 0 12px;
			font-size: 13px;
			font-weight: 400;
			line-height: 18px;
			letter-spacing: 0.001px;
		}
	}
}
</style>